import { ContainerStatus } from '@rematter/frontend-lib-api-client';

import { ContainerStatusCounts } from '../types/container';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const containerStatusCountsQueryAtom = createQueryAtomFactory(
  'trade.containerStatusCounts',
  (params: {
    bookingIds?: string[];
    containerTypeIds?: string[];
    facilityIds?: string[];
    loadIds?: string[];
    status?: ContainerStatus[];
    containerNumber?: string;
    searchTerm?: string;
  }) => ({
    containerStatusCounts: {
      __args: {
        filter: {
          bookingIds: params.bookingIds,
          containerTypeIds: params.containerTypeIds,
          facilityIds: params.facilityIds,
          loadIds: params.loadIds,
          status: params.status,
          containerNumber: params.containerNumber,
          searchTerm: params.searchTerm,
        },
      },
      atPort: true,
      inTransitToFacility: true,
      atFacilityEmpty: true,
      atFacilityLoaded: true,
      inTransitToPort: true,
      atPortReadyToShip: true,
      shipped: true,
      voided: true,
      total: true,
    },
  }),
  {
    select: (data): ContainerStatusCounts => {
      if (!data || !data.containerStatusCounts) {
        return {
          atPort: 0,
          inTransitToFacility: 0,
          atFacilityEmpty: 0,
          atFacilityLoaded: 0,
          inTransitToPort: 0,
          atPortReadyToShip: 0,
          shipped: 0,
          voided: 0,
          total: 0,
        };
      }

      return {
        atPort: data.containerStatusCounts.atPort,
        inTransitToFacility: data.containerStatusCounts.inTransitToFacility,
        atFacilityEmpty: data.containerStatusCounts.atFacilityEmpty,
        atFacilityLoaded: data.containerStatusCounts.atFacilityLoaded,
        inTransitToPort: data.containerStatusCounts.inTransitToPort,
        atPortReadyToShip: data.containerStatusCounts.atPortReadyToShip,
        shipped: data.containerStatusCounts.shipped,
        voided: data.containerStatusCounts.voided,
        total: data.containerStatusCounts.total,
      };
    },
  },
);
